
// тип документа (Например Договор или Акт)

export class DocumentType {

    // number
    Id;
    // string
    Name;

    constructor(DataFromServer) {
        this.Id = DataFromServer.Id;
        this.Name = DataFromServer.Name;
    }
}